import { getRootStore } from "@/stores/RootStore";
import { RoutePointMapper } from "@/adapters/RoutePoint.mapper";
import { supabase } from "@/utils/supabase";
export class RoutePointsService {
    constructor() { }
    async get(routeId) {
        try {
            // Include order data (orderNumber, status) for display purposes.
            // Загружаем ВСЕ точки маршрута, включая soft-deleted (isDeleted=true),
            // чтобы диспетчер видел отменённые заказы в истории маршрута.
            const { data, error } = await supabase()
                .from("route_points")
                .select(`*, order:orders!idOrder(orderNumber, status)`)
                .order("orderIndex", { ascending: true })
                .eq("idRoute", routeId);
            if (error) {
                throw new Error(`Failed to load route points: ${error.message}`);
            }
            // Flatten order fields into the DTO before mapping
            return data.map((raw) => {
                const orderData = Array.isArray(raw.order) ? raw.order[0] : raw.order;
                const dto = {
                    ...raw,
                    orderNumber: orderData?.orderNumber ?? undefined,
                    orderStatus: orderData?.status ?? undefined,
                };
                return RoutePointMapper.toDomain(dto);
            });
        }
        catch (error) {
            console.error("Error in RoutePointsService.get:", error);
            throw error;
        }
    }
    async create(routeId, routePoints) {
        // Convert Domain to DTO using mapper
        const routePointDtos = routePoints.map((routePoint, index) => {
            const newRp = {
                ...routePoint,
                orderIndex: index,
                updatedAt: new Date().toISOString(),
                idUpdatedBy: getRootStore().authStore.user?.id,
                isDeleted: false,
                idRoute: routeId,
            };
            return RoutePointMapper.toCreateDto(newRp);
        });
        const { data, error } = await supabase()
            .from("route_points")
            .insert(routePointDtos)
            .select(`*`);
        if (error) {
            throw new Error(`Failed to create route points: ${error.message}`);
        }
        return data.map((dto) => RoutePointMapper.toDomain(dto));
    }
    async update(routeId, routePoints) {
        await this.delete(routeId);
        return this.create(routeId, routePoints);
    }
    async delete(routeId) {
        // Hard delete all route_points for this route
        const { error } = await supabase()
            .from("route_points")
            .delete()
            .eq("idRoute", routeId);
        if (error) {
            throw new Error(`Failed to delete route points: ${error.message}`);
        }
    }
}
export const routePointsService = new RoutePointsService();
